import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Carousel from "react-bootstrap/Carousel";
import { Redirect, useLocation } from "react-router";
import Navbar from "../Navbar/Navbar";
import "./Main.css";
import config from "../../config/apiConfig";
import fp from "../../config/filterPref";
import { Link } from "react-router-dom";
import RingLoader from "react-spinners/RingLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { ExpandMore, Visibility } from "@material-ui/icons";
import audience from "../../icons/audience.png";
import black from "../../black.jpg";
import { push as Menu } from "react-burger-menu";
import { useMediaQuery } from "react-responsive";
import TextUtil from "../../utils/textUtil";
import { getInfo } from "../../utils/hooks";
import StoryCard from '../Main/StoryCard/StoryCard';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Main(props) {
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    window.onclick = function (event) {
        console.log(!event.target.matches(".check__container"));
        if (
            !event.target.matches(".dropbtn") &&
            !event.target.matches(".dropdown-content") &&
            !event.target.matches(".filter__check") &&
            !event.target.matches(".check__container") &&
            !event.target.matches(".checkmark")
        ) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) {
                    openDropdown.classList.remove("show");
                }
            }
        }
    };
    const article_tag = useQuery().get("article_tag");
    const entity = useQuery().get("entity");
    const person_entity = useQuery().get("person_entity");
    const query = useQuery().get("query");
    console.log(article_tag, entity);
    const [token, setToken] = useState("");
    const [filterPrefs, setFilterPrefs] = useState({});

    const [hasTimeline, setHasTimeline] = useState(false);
    const [currentFilter, setCurrentFilter] = useState({
        genre: [],
        sub_genre: [],
        language: [],
        country: [],
        state: [],
        city: [],
        sentiment: [],
        protagonist: [],
        emotion: [],
    });
    const [storyList, setStoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [currCount, setCurrCount] = useState(1);
    const [relevenaceScore, setrelevenaceScore] = useState("desc");

    function handleShowMore(e) {
        e.preventDefault();
        setCurrCount(currCount + 1);
    }

    function handleRelevenace(e) {
        setrelevenaceScore(e.target.value);
        setIsLoading(true);
    }
    useEffect(() => {
        fetch(config.BASE_URL + "/idam/get/static/filter_preferences.json")
            .then((response) => response.json())
            .then((resp) => {
                setFilterPrefs(resp);
                console.log(resp);
            });
    }, []);

    useEffect(() => {
        const formData = new FormData();
        const filterJson = {
            genre: currentFilter.genre.toString(),
            subgenre: currentFilter.sub_genre.toString(),
            language: currentFilter.language.toString(),
            country: currentFilter.country.toString(),
            state: currentFilter.state.toString(),
            city: currentFilter.city.toString(),
            protagonist: currentFilter.protagonist.toString(),
            emotion: currentFilter.emotion.toString(),
            sentiment: currentFilter.sentiment.toString(),
            has_timeline: hasTimeline,
        };
        if (article_tag) filterJson.article_tag = article_tag;
        if (entity) filterJson.entity = entity;
        if (person_entity) filterJson.person_entity = person_entity;

        formData.append("filters", JSON.stringify(filterJson));
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.adminToken);
        formData.append("order", "relevenace_score:" + relevenaceScore);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL +
                "/admin_api/search/stories?q=" +
                query +
                "&climit=32&page=" +
                currCount,
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                if (resp.data.length < 32) {
                    setCanLoadMore(false);
                }
                if (currCount === 1) {
                    setStoryList(resp.data);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify(resp.data)
                    );
                } else {
                    setStoryList([...storyList, ...resp.data]);
                    localStorage.setItem(
                        "story_list",
                        JSON.stringify([...storyList, ...resp.data])
                    );
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });
        console.log(filterJson);
    }, [currentFilter, currCount, relevenaceScore]);

    function handleChange(e, arr) {
        const name = e.target.name;
        if (name === "timeline") {
            setHasTimeline(!hasTimeline);
            setCurrentFilter({ ...currentFilter });
            return;
        }
        setCurrCount(50);
        if (!arr) arr = [];
        var ind = -1;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === e.target.value) {
                ind = i;
                break;
            }
        }
        if (ind != -1) {
            arr.splice(ind, 1);
        } else {
            arr.push(e.target.value);
        }
        if (name == "genre") {
            if (e.target.checked) {
                document.getElementById(`sub ${e.target.value}`).style.display =
                    "block";
            } else {
                document.getElementById(`sub ${e.target.value}`).style.display =
                    "none";
            }
        }
        setCurrentFilter({ ...currentFilter });
        console.log(currentFilter);
    }
    function handleDrop(e) {
        document.getElementById(e.target.name)?.classList.toggle("show");
    }
    function handleNoImage(e) {
        e.target.src = black;
    }
    return (
        <div id="outer-container">
            <Navbar style={{ boxShadow: "5px 2px 10px #edeaed" }} />
            <div className="main__content" id="main" style={{ marginTop: "0" }}>
                {/* {isTabletOrMobile ? (
                    <Menu right>
                        <div className="navbar__left" style={{display:'flex'}}>
                            <div className="navbar__img"></div>
                            <h2 className="logo">Pencil</h2>
                        </div>
                        <a className="navbar__link__active" style={{margin: "40px 0"}}>Discover</a>
                        <a className="navbar__link" style={{margin: "40px 0"}}>Friends</a>
                        <a className="navbar__link" style={{margin: "40px 0"}}>Messages</a>
                    </Menu>
                ):( */}
                <div className="filters" style={{ zIndex: 1 }}>
                    <h2
                        className="big__heading"
                        style={{ marginLeft: "auto", marginTop: "115px" }}
                    >
                        Hi {getInfo()?.name ?? "User"}, here are the stories related to "{query}"
                    </h2>
                </div>
                {/* )} */}
                <div className="main__list">
                    <div style={{ margin: "0 140px" }}>
                        {isLoading && currCount === 1 ? (
                            <RingLoader
                                color="rgb(81,35,67)"
                                loading={isLoading}
                            />
                        ) : (
                            <div className="story__sec">
                                {storyList.length === 0 ? (
                                    <p>No Stories Found.</p>
                                ) : (
                                    storyList.map((story, index) => {
                                        return (
                                            <div
                                                    key={index}
                                                    onClick={() => props.history.push(`/admin/story/${story.id}`)}
                                                    className="story__title"
                                                >
                                                    <StoryCard
                                                        index={index}
                                                        isRead={story.isViewed}
                                                        isAdded={story.isInScrapebook}
                                                        image={
                                                            story.images[0]
                                                                ?.link
                                                        }
                                                        score={
                                                            story.story_score
                                                        }
                                                        id={story.id}
                                                        title={story.title}
                                                        isLiked={story.isLiked}
                                                        fb_comments={
                                                            story
                                                                .social_media_scores_details
                                                                ?.fb_comments
                                                        }
                                                        fb_shares={
                                                            story
                                                                .social_media_scores_details
                                                                .fb_shares
                                                        }
                                                        fb_reactions={
                                                            story
                                                                .social_media_scores_details
                                                                ?.fb_reactions
                                                        }
                                                    />
                                                </div>
                                        );
                                    })
                                )}
                            </div>
                        )}
                        {(!isLoading && canLoadMore) && (
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: "20px",
                                }}
                            >
                                <button
                                    onClick={handleShowMore}
                                    className="borderless__btn"
                                    style={{ margin: "auto" }}
                                >
                                    Show More <ExpandMore />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;
